'use client'
import { useEffect, useRef } from 'react'
import { useSearchParams } from 'next/navigation'
import { useMonkeCatalog } from '@/utils/hooks/useMonkeDiscovery'
import useInscriptionModal from '@/utils/hooks/useInscriptionModal'

export default function SharedMonke() {
	const params = useSearchParams()
	const number = Number(params?.get('monke'))
	const { data } = useMonkeCatalog(Number.isInteger(number) && number >= 1 && number <= 10000)
	const lastOpened = useRef<string | null>(null)
	const open = useInscriptionModal()
	useEffect(() => {
		const monke = data?.items.find((m) => m.number === number)
		if (!monke) { lastOpened.current = null; return }
		if (lastOpened.current === monke.id) return
		lastOpened.current = monke.id
		open({ id: monke.id, inscription: { id: monke.id, content_type: 'image/png', meta: { name: `NodeMonke #${monke.number}` }, collection: { slug: 'nodemonkes', name: 'NodeMonkes' } } })
	}, [number, data, open])
	return null
}
